"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.putData = exports.postData = exports.getData = exports.deleteData = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var updateConfig = function updateConfig(_ref, config) {
  var accessToken = _ref.accessToken;
  var defaultHeaders = {
    Accept: 'application/json',
    Authorization: "Bearer ".concat(accessToken)
  };
  config.headers = _objectSpread(_objectSpread({}, defaultHeaders), config.headers);
  return config;
}; // first arg is for additional data like accessToken, environment, etc.
// send your query params as config.params


var getData = function getData(_ref2, url) {
  var accessToken = _ref2.accessToken;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  config = updateConfig({
    accessToken: accessToken
  }, config);
  return _axios["default"].get(url, config);
};

exports.getData = getData;

var postData = function postData(_ref3, url, data) {
  var accessToken = _ref3.accessToken;
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  config = updateConfig({
    accessToken: accessToken
  }, config);
  return _axios["default"].post(url, data, config);
};

exports.postData = postData;

var deleteData = function deleteData(_ref4, url) {
  var accessToken = _ref4.accessToken;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  config = updateConfig({
    accessToken: accessToken
  }, config);
  return _axios["default"]["delete"](url, config);
};

exports.deleteData = deleteData;

var putData = function putData(_ref5, url, data) {
  var accessToken = _ref5.accessToken;
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  config = updateConfig({
    accessToken: accessToken
  }, config);
  return _axios["default"].put(url, data, config);
};

exports.putData = putData;